/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoWrikeDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-wrike-dev" */ './utils').then(
			(m) => m.ForgeUnitoWrikeDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-dev/icon' },
);

const LazyForgeUnitoWrikeDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-wrike-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoWrikeDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoWrikeDevIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoWrikeDevIconComponent />
	</Suspense>
);

export const ForgeUnitoWrikeDevSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoWrikeDevSearchResultIconComponent />
	</Suspense>
);
